import { forwardRef as l } from "react";
const c = (e, t) => t ? t.filter((o) => {
  const n = o.label.toLowerCase(), i = e.toLowerCase();
  return n.includes(i);
}) : [];
let r;
const f = (e, t = 500) => (clearTimeout(r), r = setTimeout(async () => {
  await e();
}, t), r), u = (e) => (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  l(e)
);
export {
  f as debounce,
  c as filterOptions,
  u as typedForwardRef
};
//# sourceMappingURL=tools.js.map
